const COLORS: Array<{ bg: string; fg: string; border: string }> = [
  {
    bg: "hsl(var(--green-300))",
    fg: "hsl(var(--green-950))",
    border: "hsl(var(--green-600))",
  },
  {
    bg: "hsl(var(--raspberry-300))",
    fg: "hsl(var(--raspberry-950))",
    border: "hsl(var(--raspberry-600))",
  },
  {
    bg: "hsl(var(--blue-300))",
    fg: "hsl(var(--blue-950))",
    border: "hsl(var(--blue-600))",
  },
  {
    bg: "hsl(var(--yellow-300))",
    fg: "hsl(var(--yellow-950))",
    border: "hsl(var(--yellow-600))",
  },
  {
    bg: "hsl(var(--pistachio-300))",
    fg: "hsl(var(--pistachio-950))",
    border: "hsl(var(--pistachio-600))",
  },
];

export function getFallbackAvatarColor(id: string) {
  const hash = id.split("").reduce((acc, char) => {
    return acc + char.charCodeAt(0);
  }, 0);
  const color = COLORS[hash % COLORS.length];
  return color;
}
